import { ComponentType } from 'react'
import TelegramInShape from '@shared/svg/in-shape/telegram.svg'
import YoutubeInShape from '@shared/svg/in-shape/youtube.svg'

interface Social {
	title: string
	href: string
	IconComponent: ComponentType<any>
}

export const socials: Social[] = [
	{
		title: 'Наш telegram канал',
		href: 'https://t.me/partnerscreditclub',
		IconComponent: TelegramInShape,
	},
	{
		title: 'Наш youtube канал',
		href: 'https://www.youtube.com/channel/UCmSKC-7TCBJEQla4Mfo-Gzg',
		IconComponent: YoutubeInShape,
	},
]
